<template>
  <div class="container-fluid">
    <apexchart :key="renderkey" height="850" :options="ApexChartOptions" :series="ApexChartOptions.series"></apexchart>
  </div>
</template>
<script>
export default {
  data() {
    return {
      renderkey: 0,
      ApexChartOptions: {
        chart: {
          type: 'donut',
        },
        dataLabels: {
          enabled: false,
        },
        colors: this.theme == 1 ? ['#5CB0FF', '#FDA700', '#fd397a', '#21AE89', '#5578eb', '#11e345', '#78eb8d', '#f56905'] : ['#2F4F4F', '#778899', '#C0C0C0', '#778899', '#5578eb', '#11e345', '#78eb8d', '#f56905'],
        series: [],
        labels: [],
        stroke: {
          show: false,
        },
      },
    }
  },
  props: ['ChartData', 'Height', 'theme', 'fixedSeries'],
  created() {
    this.ApexChartOptions.series = []
    this.ApexChartOptions.labels = []
    if (this.fixedSeries) {
      this.ApexChartOptions.labels = this.fixedSeries
      for (let index = 0; index < this.ApexChartOptions.labels.length; index++) {
        const element = this.ApexChartOptions.labels[index]
        var temp = this.ChartData.find((x) => x.label == element)
        if (temp) {
          this.ApexChartOptions.series.push(temp.value)
        } else {
          this.ApexChartOptions.series.push(0)
        }
      }
    } else {
      this.ChartData.forEach((element) => {
        this.ApexChartOptions.labels.push(element.label)
        this.ApexChartOptions.series.push(element.value)
        this.renderkey++
      })
    }
  },
}
</script>
